import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import Tooltip from 'components/Tooltip';

const QUICK_FILTERS = [
  { label: 'Todos', value: 'all' },
  { label: 'Procesando', value: 'Procesando' },
  { label: 'Listo para Venta', value: 'Listo para Venta' },
  { label: 'En Espera', value: 'En Espera' },
  { label: 'Vendido', value: 'Completado' },
];

const METAL_OPTIONS = ['Todos', 'Cobre', 'Aluminio', 'Plomo', 'Zinc', 'Níquel', 'Estaño'];

export default function BatchFilters({
  searchQuery, setSearchQuery,
  activeFilter, setActiveFilter,
  metalFilter, setMetalFilter,
  dateFrom, setDateFrom,
  dateTo, setDateTo,
  resultCount,
  onClearFilters,
}) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4 md:p-5 space-y-4">
      {/* Search + Metal + Date Row */}
      <div className="flex flex-col md:flex-row gap-3">
        {/* Search */}
        <div className="relative flex-1">
          <Icon name="Search" size={16} color="var(--color-muted-foreground)" className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
          <input
            type="text"
            placeholder="Buscar por ID o metal..."
            value={searchQuery}
            onChange={e => setSearchQuery(e?.target?.value)}
            className="w-full pl-9 pr-4 py-2 text-sm border border-slate-200 rounded-lg bg-slate-50 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
            style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}
          />
          {searchQuery && (
            <button onClick={() => setSearchQuery('')} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600">
              <Icon name="X" size={14} color="currentColor" />
            </button>
          )}
        </div>

        {/* Metal Filter */}
        <Tooltip description="Filtra los lotes por tipo de metal. Selecciona un metal específico para ver solo sus lotes.">
          <select
            value={metalFilter}
            onChange={e => setMetalFilter(e?.target?.value)}
            className="px-3 py-2 text-sm border border-slate-200 rounded-lg bg-slate-50 focus:outline-none focus:ring-2 focus:ring-orange-500 min-w-[140px]"
            style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}
          >
            {METAL_OPTIONS?.map(m => <option key={m} value={m}>{m}</option>)}
          </select>
        </Tooltip>

        {/* Date From */}
        <Tooltip description="Fecha de inicio del rango. Muestra solo los lotes creados a partir de esta fecha.">
          <input
            type="date"
            value={dateFrom}
            onChange={e => setDateFrom(e?.target?.value)}
            className="px-3 py-2 text-sm border border-slate-200 rounded-lg bg-slate-50 focus:outline-none focus:ring-2 focus:ring-orange-500"
            style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}
          />
        </Tooltip>
        <Tooltip description="Fecha de fin del rango. Muestra solo los lotes creados hasta esta fecha.">
          <input
            type="date"
            value={dateTo}
            onChange={e => setDateTo(e?.target?.value)}
            className="px-3 py-2 text-sm border border-slate-200 rounded-lg bg-slate-50 focus:outline-none focus:ring-2 focus:ring-orange-500"
            style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}
          />
        </Tooltip>

        {/* Clear */}
        <Tooltip description="Restablece todos los filtros activos: búsqueda, metal, fechas y estado.">
          <Button variant="ghost" size="sm" iconName="RotateCcw" iconPosition="left" onClick={onClearFilters}>
            Limpiar
          </Button>
        </Tooltip>
      </div>
      {/* Quick Filter Chips + Result Count */}
      <div className="flex flex-wrap items-center gap-2">
        {QUICK_FILTERS?.map(f => (
          <button
            key={f?.value}
            onClick={() => setActiveFilter(f?.value)}
            className={`px-3 py-1 rounded-full text-xs font-medium border transition-all ${
              activeFilter === f?.value
                ? 'bg-orange-600 text-white border-orange-600' :'bg-white text-slate-600 border-slate-200 hover:border-orange-300 hover:text-orange-600'
            }`}
            style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}
          >
            {f?.label}
          </button>
        ))}
        <Tooltip description="Número de lotes que coinciden con los filtros activos actualmente.">
          <span className="ml-auto text-xs text-slate-500 cursor-help" style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>
            {resultCount} resultado{resultCount !== 1 ? 's' : ''}
          </span>
        </Tooltip>
      </div>
    </div>
  );
}